/**
 * İkon seti — inline SVG, stroke tabanlı (§1.6).
 * `stroke: currentColor` olduğu için renk üst öğeden gelir.
 */
export type IconName =
  | 'grid'
  | 'list'
  | 'users'
  | 'van'
  | 'pin'
  | 'box'
  | 'car'
  | 'wallet'
  | 'drop'
  | 'link'
  | 'chart'
  | 'sliders'
  | 'search'
  | 'bell'
  | 'eye'
  | 'check'
  | 'x'
  | 'chevron-down'
  | 'arrow-right'
  | 'alert-triangle'
  | 'alert-circle'
  | 'info'
  | 'funnel'
  | 'refresh'
  | 'download'
  | 'clock'
  | 'menu'
  | 'print';

const PATHS: Record<IconName, string> = {
  grid: 'M3 3h7v7H3zM11 3h7v7h-7zM3 11h7v7H3zM11 11h7v7h-7z',
  list: 'M6 5h11M6 10.5h11M6 16h11M3 5h.01M3 10.5h.01M3 16h.01',
  users:
    'M13 16v-1a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v1M7.5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6M18 16v-1a3 3 0 0 0-2.2-2.9M13.5 3.2a3 3 0 0 1 0 5.6',
  van: 'M1 13V5h10v8M11 8h3.5l2.5 3v2h-2M3.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3',
  pin: 'M10 17s6-5.2 6-9.4A6 6 0 0 0 4 7.6C4 11.8 10 17 10 17M10 10a2.2 2.2 0 1 0 0-4.4A2.2 2.2 0 0 0 10 10',
  box: 'M10 2 3 5.5v9L10 18l7-3.5v-9zM3 5.5 10 9l7-3.5M10 9v9',
  car: 'M3 12h14M4.5 12 6 7h8l1.5 5M4.5 12v3M15.5 12v3M6.5 15h.01M13.5 15h.01',
  wallet:
    'M3 6.5h11a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a1 1 0 0 1-1-1zM3 6.5v-1a1 1 0 0 1 1-1h9M13 11h1',
  drop: 'M10 2.5s5 5.4 5 8.6a5 5 0 0 1-10 0C5 7.9 10 2.5 10 2.5',
  link: 'M8 12l4-4M7 9 5 11a2.8 2.8 0 0 0 4 4l2-2M13 11l2-2a2.8 2.8 0 0 0-4-4L9 7',
  chart: 'M3 17h14M6 14V8M10 14V4M14 14v-6',
  sliders: 'M3 6h14M3 14h14M8 3.5v5M13 11.5v5',
  search: 'M9 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12M13.5 13.5 17 17',
  bell: 'M10 3a4.5 4.5 0 0 0-4.5 4.5c0 3-1.5 4-1.5 4h12s-1.5-1-1.5-4A4.5 4.5 0 0 0 10 3M8.5 14a1.6 1.6 0 0 0 3 0',
  eye: 'M1.8 10S4.7 5 10 5s8.2 5 8.2 5-2.9 5-8.2 5S1.8 10 1.8 10M10 12.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4',
  check: 'M4 10.5 8 14.5 16 6',
  x: 'M5 5l10 10M15 5 5 15',
  'chevron-down': 'M5 8l5 5 5-5',
  'arrow-right': 'M4 10h11M11 6l4 4-4 4',
  'alert-triangle': 'M10 3 2.5 16h15zM10 8v4M10 14h.01',
  'alert-circle': 'M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14M10 6.5v5M10 13.5h.01',
  info: 'M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14M10 9v4.5M10 6.5h.01',
  funnel: 'M3 4h14l-5.5 6.5V17l-3-2v-4.5z',
  refresh: 'M16 8a6 6 0 1 0-1.5 6M16 3.5V8h-4.5',
  download: 'M10 3v9M6.5 9 10 12.5 13.5 9M4 16h12',
  clock: 'M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14M10 6v4.4l3 1.8',
  menu: 'M3 5.5h14M3 10h14M3 14.5h14',
  print:
    'M6 7V3h8v4M6 14H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2M6 11h8v6H6z',
};

export function Icon({
  name,
  size = 18,
  strokeWidth = 1.6,
}: {
  name: IconName;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
